/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService, LogService } from '../../../../core/services';
import { Injectable } from '@angular/core';
import { LicenceEnum } from '../enums/api';
import { LicenceModel } from '../models';
import { ModulesEnum } from '../../../../core/enums';
import { Observable } from 'rxjs';

@Injectable()
export class LicenceApiService {
    constructor(
        private apiService: ApiService,
        private authStoreService: AuthStoreService,
        private logService: LogService,
    ) {
    }

    /**
     * Get the licence details.
     * @returns {any}
     */
    public getLicenceDetails(options?: any): Observable<LicenceModel> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.apiService.get(
                LicenceEnum.GET_LICENSE,
                moduleAuth,
                false
            ).subscribe(
                (data) => {
                    const licence: LicenceModel = <LicenceModel>data;
                    observer.next(licence);
                    observer.complete();
                },
                error => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * update the licence details.
     * @param licenceKey
     * @param options
     */
    public updateLicenceDetails(licenceKey: string, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            if (!licenceKey) {
                this.logService.error('Parameter not set', 'licenceKey not set');

                return;
            }

            this.apiService.put(
                LicenceEnum.PUT_LICENCE,
                { licenceKey: licenceKey },
                moduleAuth,
                false
            ).subscribe(
                data => {
                    observer.next(data);
                    observer.complete();
                },
                error => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }
}
